// Angular
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

// Libraries
import { Observable } from 'rxjs';

// Afidium
import { ProcessingService } from 'libraries/service/processing/processing.service';
import { BookingResourceService } from 'libraries/service/resources/booking/bookingResource.service';
import { IGetBookingsCommonResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';

@Injectable()
export class BookingQualityCheckResolver implements Resolve<IGetBookingsCommonResponse[]> {
    constructor(
        private readonly processingService: ProcessingService,
        private readonly bookingResourceService: BookingResourceService
    ) { }

    public resolve(): Observable<IGetBookingsCommonResponse[]> {
        const bookingSyscodes: string[] = this.processingService.bookings.map((booking: IGetBookingsCommonResponse) => booking.syscode);
        return this.bookingResourceService.getBookingsBySyscodeWithFilter(bookingSyscodes, this.processingService.searchParams, false, false, false,true);
    }
}
